/**
 * Range Slider Click-to-Filter Fix
 * Enables clicking on range slider track to update filters automatically
 */

(function() {
  'use strict';
  
  // Wait for DOM to be ready
  function init() {
    // Find all range sliders with the class used by your theme
    const rangeSliders = document.querySelectorAll('.price-range');
    
    if (!rangeSliders.length) return;
    
    // Give noUiSlider time to initialize
    setTimeout(function() {
      rangeSliders.forEach(function(rangeContainer) {
        enhanceRangeSlider(rangeContainer);
      });
    }, 500);
  }
  
  function enhanceRangeSlider(container) {
    const sliderEl = container.querySelector('.price-range__slider, .range-slider-ui');
    
    if (!sliderEl || !sliderEl.noUiSlider) {
      console.warn('NoUiSlider not found on element:', sliderEl);
      return;
    }
    
    const slider = sliderEl.noUiSlider;
    const sliderBase = sliderEl.querySelector('.noUi-base');
    
    if (!sliderBase) return;
    
    // Check if already enhanced to avoid duplicate listeners
    if (sliderBase.dataset.clickEnhanced === 'true') return;
    sliderBase.dataset.clickEnhanced = 'true';
    
    sliderBase.addEventListener('click', function(event) {
      // Ignore if clicking on handles
      if (event.target.classList.contains('noUi-handle') || 
          event.target.closest('.noUi-handle')) {
        return;
      }
      
      // Wait for noUiSlider to update the position after click
      setTimeout(function() {
        triggerFilterUpdate(container, slider);
      }, 100);
    });
  }
  
  function triggerFilterUpdate(container, slider) {
    const values = slider.get();
    const sliderType = container.dataset.rangeSliderUnit;
    const inputMinEl = container.querySelector('.price-range__input-min, .data-range-slider-min');
    const inputMaxEl = container.querySelector('.price-range__input-max, .data-range-slider-max');
    
    if (!inputMinEl || !inputMaxEl) return;
    
    if (sliderType === 'integer') {
      // Integer range (e.g., Max Lumens, Runtime, Beam Distance)
      const intValues = values.map(num => parseInt(num));
      inputMinEl.value = intValues[0];
      inputMaxEl.value = intValues[1];
      
      // Build filter string from data-values
      const dataValues = container.dataset.values ? container.dataset.values.split(',') : [];
      let filterParamsString = "";
      let index = 0;
      
      dataValues.forEach(function(val) {
        const numVal = parseFloat(val.trim());
        if (numVal >= intValues[0] && numVal <= intValues[1]) {
          filterParamsString += (index !== 0 ? "," : "") + val.trim();
          index++;
        }
      });
      
      // Update URL and reload
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set(container.dataset.minName, filterParamsString);
      let paramsString = searchParams.toString().replace(/\+/g, "").replace(/%2C/g, ",");
      window.location.search = paramsString;
      
    } else if (sliderType === 'currency') {
      // Currency/price range
      const floatValues = values.map(num => parseFloat(num));
      inputMinEl.value = floatValues[0];
      inputMaxEl.value = floatValues[1];
      
      // Find and submit the form
      const form = container.closest('form');
      if (form) {
        const formData = new FormData(form);
        
        // Trigger collection filter update
        if (window.theme && window.theme.Collection) {
          // Use theme's built-in method if available
          const searchParams = new URLSearchParams(formData);
          const collectionSection = document.querySelector('[data-section-type="collection-grid"]');
          
          if (collectionSection) {
            const event = new CustomEvent('filter:update', {
              detail: { formData: formData }
            });
            collectionSection.dispatchEvent(event);
          }
        } else {
          // Fallback: submit the form
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    }
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize when collection reloads (for AJAX filtering)
  document.addEventListener('collection:reloaded', function() {
    setTimeout(init, 500);
  });
  
  // Re-initialize when sections are loaded in theme editor
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 500);
  });
  
})();